import { Consumption } from '../../schema/VehicleTileDataSchema';
import type { ParsedTechnicalData } from './TechnicalDataOneSearch';

export const processOneSearchConsumption = (parsedTechnicalData: Partial<ParsedTechnicalData>): Consumption[] => {
  return parsedTechnicalData.emissionData ?? [];
};
